import {
    css, Theme,
} from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        main: css`
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 50px;
            color: ${theme.palette.secondary[600]};
        `,
        info: css`
            width: 50%;
            display: flex;
            flex-direction: column;
            justify-content: start;
        `,
        context: css`
            display: flex;
            flex-direction: column;
            justify-content: start;
            padding-top: 20px;
            padding-bottom: 20px;
        `,
        text: css`
            font-size: ${theme.typography.h3.fontSize}px;
            line-height: ${theme.typography.h3.lineHeight};
            color: ${theme.palette.secondary[600]};
        `,
        tempValue: css`
            font-weight: 900;
            color: ${theme.palette.secondary[600]};
        `,
        actions: css`
            ${common.flexJustityAlignCenter};
        `,
        button: css`
            margin: 60px 25px 15px 25px;
            ${custom.button};
        `,
    }
}

export default styles
